import { fetchAsPost } from "./api.service";
import { API_HISTORY } from "../helpers/apiURL";
import { handleResData } from "./api.handleRespone";

export async function getDetail(params, dispatch) {
  const res = await fetchAsPost(API_HISTORY.DETAIL, params);

  return handleResData(res, dispatch);
}
